import React from 'react'
import PropTypes from 'prop-types'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { Box, DashboardModuleListItem, DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import useAgencies from '@hooks/useAgencies'
import { generateUrls } from '@hooks/useAgency'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Title or ID',
    },
  ]
}

const BrandAgencies = (props) => {
  const { brandId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const agenciesPayload = useAgencies({
    filters: { brand_id: brandId, ...pageFilters },
    performHttpRequests: !!brandId,
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredAgencies,
    filteredAgenciesCount,
    hasFilteredAgencies,
    loading,
  } = agenciesPayload

  return (
    <DashboardModule
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Agencies"
    >
      <Box flexDirection="column">
        <DashboardModuleFilters
          filterFields={buildPageFilterFields()}
          {...filterPayload}
        />

        <DashboardModule.ScrollableSection maxHeight={600}>
          {!loading && !hasFilteredAgencies && (
            <DashboardModule.BlankState>
              <DashboardModule.BlankState.Title>
                No Agencies present
              </DashboardModule.BlankState.Title>

              <DashboardModule.BlankState.Paragraph>
                Please adjust your filters or assign an Agency.
              </DashboardModule.BlankState.Paragraph>
            </DashboardModule.BlankState>
          )}

          {filteredAgencies.map((agency) => {
            const { editAgencyUrl } = generateUrls(agency)

            return (
              <DashboardModuleListItem
                key={agency.id}
                title={agency.title}
              >
                <DashboardModuleListItem.TertiaryText># {agency.id}</DashboardModuleListItem.TertiaryText>

                <DashboardModuleListItem.Actions>
                  <DashboardModuleListItem.Icon href={`${editAgencyUrl}?redirect=${generateRedirectUrl()}`} type="link" />
                </DashboardModuleListItem.Actions>
              </DashboardModuleListItem>
            )
          })}
        </DashboardModule.ScrollableSection>

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredAgenciesCount}
          loading={loading}
        />
      </Box>
    </DashboardModule>
  )
}

BrandAgencies.propTypes = {
  brandId: PropTypes.number.isRequired,
}

export default BrandAgencies
